import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
// import { ModalWhatsappComponent } from 'src/app/componentss/modal-whatsapp/modal-whatsapp.component';
import { MatDialog } from '@angular/material/dialog';
import { isPlatformBrowser } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-thank-you-page',
  templateUrl: './thank-you-page.component.html',
  styleUrl: './thank-you-page.component.scss'
})
export class ThankYouPageComponent {
  private readonly siteUrl = environment.SITE_URL;

  public type: string = 'contacto';
  public message: string = '';

  public texts: any = {
    contacto: {
      title: '¡Gracias por contactarnos!',
      message: 'Hemos recibido tu mensaje correctamente. Nuestro equipo se pondrá en contacto contigo lo antes posible para ayudarte.',
    },
    cotizacion: {
      title: '¡Estamos preparando tu propuesta!',
      message: 'Tu solicitud ha sido recibida con éxito. Pronto recibirás una cotización detallada directamente en tu correo electrónico.',
    },
    whatsapp: {
      title: '¡Estamos conversando!',
      message: 'Gracias por escribirnos por WhatsApp. Te responderemos en breve directamente por ese canal. ¡Hablemos!',
    },
    telefono: {
      title: '¡Gracias por comunicarte con nosotros!',
      message: 'Estamos redirigiéndote para que puedas llamarnos directamente. ¡Gracias por tu interés!',
    },
  };

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: any,
    private titleService: Title,
    private metaService: Meta,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  ngOnInit(): void {
    const urlSegment = this.activeRoute.snapshot.url.map(s => s.path);
    const typeFromPath = urlSegment[1];
    if (typeFromPath) {
      this.type = typeFromPath;
      this.setMetaTags();
      if (this.type === 'whatsapp' || this.type === 'telefono') {
        this.activeRoute.queryParams.subscribe(query => {
          this.message = query['message'] ?? '';
        });
        this.goRedirect();
      }
    }
  }

  goHome() {
    this.router.navigate(['/inicio']);
  }

  openModalWhats(data: any) {
    // const dialogRef = this.dialog.open(ModalWhatsappComponent, {
    //   data: data,
    //   maxHeight: '95vh',
    //   maxWidth: '768px',
    // });
  }

  goRedirect() {
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        if (this.type === 'telefono') {
          const phoneNumber = '525581083995';
          const telLink = document.createElement('a');
          telLink.href = `tel:${phoneNumber}`;
          telLink.click();
        } else if (this.type === 'whatsapp') {
          const url = `https://wa.me/525581083995`;
          window.open(url, '_blank');
        }
      }, 2000);
    }
  }

  private getMetaConfig(): { title: string; description: string; path: string; keywords: string } {
    if (this.type === 'whatsapp') {
      return {
        title: 'Gracias por escribirnos por WhatsApp | Paredes y Asociados',
        description: 'Gracias por contactarnos por WhatsApp. Nuestro equipo de Paredes y Asociados continuará la conversación contigo en ese canal.',
        path: '/gracias/whatsapp/',
        keywords: 'Paredes y Asociados, Gracias WhatsApp, Confirmación de contacto'
      };
    }

    if (this.type === 'telefono') {
      return {
        title: 'Gracias por llamarnos por teléfono | Paredes y Asociados',
        description: 'Gracias por comunicarte por teléfono con Paredes y Asociados. Estamos listos para atender tu llamada y resolver tus dudas.',
        path: '/gracias/telefono/',
        keywords: 'Paredes y Asociados, Gracias llamada telefónica, Confirmación de contacto'
      };
    }

    return {
      title: 'Gracias por contactarnos | Paredes y Asociados',
      description: 'Hemos recibido tu contacto correctamente. En breve, alguien de Paredes y Asociados se pondrá en comunicación contigo.',
      path: '/gracias/',
      keywords: 'Paredes y Asociados, Gracias por contactarnos, Confirmación'
    };
  }

  setMetaTags(): void {
    const config = this.getMetaConfig();
    const url = `${this.siteUrl}${config.path}`;
    const image = this.getMetaImage();

    this.titleService.setTitle(config.title);
    this.metaService.updateTag({ name: 'description', content: config.description });

    this.metaService.updateTag({ name: 'robots', content: 'index, follow' });
    this.metaService.updateTag({ name: 'description', content: config.description });
    this.setCanonicalUrl(url);

    this.metaService.updateTag({ name: 'keywords', content: config.keywords });

    this.metaService.updateTag({ property: 'og:type', content: 'website' });
    this.metaService.updateTag({ property: 'og:locale', content: 'es_MX' });
    this.metaService.updateTag({ property: 'og:site_name', content: 'Paredes y Asociados' });

    this.metaService.updateTag({ property: 'og:title', content: config.title });
    this.metaService.updateTag({ property: 'og:description', content: config.description });
    this.metaService.updateTag({ property: 'og:url', content: url });
    this.metaService.updateTag({ property: 'og:image', content: image });
    this.metaService.updateTag({ property: 'og:image:alt', content: 'Paredes y Asociados' });

    this.metaService.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
    this.metaService.updateTag({ name: 'twitter:title', content: config.title });
    this.metaService.updateTag({ name: 'twitter:description', content: config.description });
    this.metaService.updateTag({ name: 'twitter:url', content: url });
    this.metaService.updateTag({ name: 'twitter:image', content: image });
  }

  private getMetaImage(): string {
    if (this.type === 'whatsapp') {
      return this.toAbsoluteUrl('/assets/images/icons/whats.png');
    }
    if (this.type === 'telefono') {
      return this.toAbsoluteUrl('/assets/images/icons/phone.png');
    }
    return this.toAbsoluteUrl('/assets/images/thank-you-page.webp');
  }

  private setCanonicalUrl(url: string): void {
    const head = this.document.head;
    let link = this.document.querySelector("link[rel='canonical']") as HTMLLinkElement | null;
    if (!link) {
      link = this.document.createElement('link');
      link.setAttribute('rel', 'canonical');
      head.appendChild(link);
    }
    link.setAttribute('href', url);
  }

  private toAbsoluteUrl(path: string): string {
    if (!path) {
      return `${this.siteUrl}/assets/images/logos/logo-full.webp`;
    }
    if (path.startsWith('http://') || path.startsWith('https://')) {
      return path;
    }
    if (!path.startsWith('/')) {
      path = `/${path}`;
    }
    return `${this.siteUrl}${path}`;
  }

}

